'use client'
import RadioGroup from '@/src/components/common/RadioGroup'
import bgimage from './bgimage.svg'
import bgimageMobile from './bgimage-mobile.svg'
import Img from '@/src/components/common/Img/Img'
import styles from '../../OnboardingForm.module.scss'
import { useState } from 'react'
import { readStoredData } from '@/src/components/common/OnboardingForm/OnboardingForm.client'

export default function WaitingForHCPMoreDetailsForm() {
  const [onboardingData, setOnboardingData] = useState(readStoredData())

  const names = [
    'more_details__waiting_hcp__phone_assessment',
    'more_details__waiting_hcp__face_to_face_appointment',
    'more_details__waiting_hcp__received_approval',
  ]

  return (
    <>
      {(() => {
        const name = names[0]
        return (
          <>
            <div>
              <div>
                <h3 className={styles.heading}>{`Have you had a phone assessment?`}</h3>
                {`Your My Aged Care phone assessment is a call to discuss your health and support needs, helping determine the care and services you may be eligible for.`}
              </div>
              <RadioGroup
                onChange={value => {
                  setOnboardingData({
                    ...onboardingData,
                    data: { ...onboardingData.data, [name]: value as string },
                  })
                }}
                required
                options={[
                  { display: 'Yes', value: 'yes' },
                  { display: 'No', value: 'no' },
                  { display: 'I’m not sure', value: 'not_sure' },
                ]}
                name={name}
                value={(onboardingData.data?.[name] || '') as string}
              />

              {onboardingData.data[names[0]] === 'yes' &&
                (() => {
                  const name = names[1]
                  return (
                    <>
                      <hr />
                      <div>
                        <div>
                          <h3 className={styles.heading}>
                            {`Have you had a face to face appointment?`}
                          </h3>
                          {`This is a government assessment, usually with an ACAT/ACAS assessor, where someone visits you at home to confirm your eligibility and the services you can access.`}
                        </div>
                      </div>
                      <RadioGroup
                        onChange={value => {
                          setOnboardingData({
                            ...onboardingData,
                            data: { ...onboardingData.data, [name]: value as string },
                          })
                        }}
                        required
                        options={[
                          { display: 'Yes', value: 'yes' },
                          { display: 'No', value: 'no' },
                          { display: 'I’m not sure', value: 'not_sure' },
                        ]}
                        name={name}
                        value={(onboardingData.data?.[name] || '') as string}
                      />

                      {onboardingData.data[names[1]] === 'yes' &&
                        (() => {
                          const name = names[2]
                          return (
                            <>
                              <hr />
                              <div>
                                <div>
                                  <h3 className={styles.heading}>
                                    {`Have you received a letter or notification saying that you’ve been approved for a Support at Home funding?`}
                                  </h3>
                                  {`This is the letter from My Aged Care confirming your funding approval and support plan.`}
                                </div>
                              </div>
                              <RadioGroup
                                onChange={value => {
                                  setOnboardingData({
                                    ...onboardingData,
                                    data: { ...onboardingData.data, [name]: value as string },
                                  })
                                }}
                                required
                                options={[
                                  { display: 'Yes', value: 'yes' },
                                  { display: 'No', value: 'no' },
                                  { display: 'I’m not sure', value: 'not_sure' },
                                ]}
                                name={name}
                                value={(onboardingData.data?.[name] || '') as string}
                              />
                            </>
                          )
                        })()}
                    </>
                  )
                })()}
            </div>
            <div>
              <Img src={bgimage.src} className={styles.desktop} />
              <Img src={bgimageMobile.src} className={styles.mobile} />
            </div>
          </>
        )
      })()}
    </>
  )
}
